import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import Router from "./Router";
const container = document.getElementById("root");
if (container) {
    const root = createRoot(container);
    root.render(_jsx(Router, {}));
}
